import { createContext, useContext, useState, useEffect } from "react";

const FunnelContext = createContext(null);
const STORAGE_KEY = "aurea_soul_funnel_answers";

export const FunnelProvider = ({ children }) => {
  const [answers, setAnswers] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : {};
    } catch {
      return {};
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(answers));
  }, [answers]);

  const setAnswer = (key, value) => {
    setAnswers((prev) => ({ ...prev, [key]: value }));
  };

  const getSegment = () => {
    const struggle = answers.q1_struggle || "";
    if (struggle.includes("anxious")) return "anxiety";
    if (struggle.includes("exhausted") || struggle.includes("burned out")) return "burnout";
    if (struggle.includes("disconnected")) return "disconnection";
    return "growth";
  };

  return (
    <FunnelContext.Provider value={{ answers, setAnswer, getSegment }}>
      {children}
    </FunnelContext.Provider>
  );
};

export const useFunnel = () => useContext(FunnelContext);
